import { useState } from "react";
import { InviteDraft } from "@/components/nobo/InviteDraft";

const KEY = "nobo-last-run";
const saved = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

const COPY = {
  invite: {
    title: (n) => `invite ${n} runner${n > 1 ? "s" : ""}`, done: "your invites", button: "write the invites",
    sub: "Tell the AI about the run. It writes one message per runner, and you can edit each one before you send it.",
    when: "when", where: "meeting spot",
  },
  nudge: {
    title: (n) => `missed-you note${n > 1 ? "s" : ""} for ${n}`, done: "your missed-you notes", button: "write the notes",
    sub: "Got next week's run lined up? Add it and the AI will mention it. Leave it blank and the note just says you'll send details.",
    when: "next run: when (optional)", where: "next run: meeting spot (optional)",
  },
};

export const InvitePanel = ({ runners, onClose, kind = "invite" }) => {
  const [form, setForm] = useState({ when: "", where: "", note: "", ...saved() });
  const [run, setRun] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const c = COPY[kind];
  const ready = kind === "nudge" || (form.when.trim() && form.where.trim());

  const start = (e) => {
    e.preventDefault();
    if (!ready) return;
    if (form.when.trim() && form.where.trim()) localStorage.setItem(KEY, JSON.stringify(form));
    setRun({ when: form.when.trim(), where: form.where.trim(), note: form.note.trim() });
  };

  return (
    <div className="org-modal" role="dialog" aria-modal="true" data-testid="invite-panel">
      <div className="org-modal-box">
        <div className="org-head">
          <h2>{run ? c.done : c.title(runners.length)}</h2>
          <button type="button" className="pill dark" onClick={onClose} data-testid="invite-panel-close">done</button>
        </div>
        {!run ? (
          <form className="card flat" onSubmit={start} data-testid="run-details-form">
            <p className="sub">{c.sub}</p>
            <label htmlFor="run-when">{c.when}</label>
            <input id="run-when" type="text" maxLength={120} value={form.when} onChange={set("when")} placeholder="sunday 6:30am" data-testid="run-when-input" />
            <label htmlFor="run-where">{c.where}</label>
            <input id="run-where" type="text" maxLength={160} value={form.where} onChange={set("where")} placeholder="carter road promenade, by the amphitheatre" data-testid="run-where-input" />
            <label htmlFor="run-note">anything else? (optional)</label>
            <input id="run-note" type="text" maxLength={300} value={form.note} onChange={set("note")} placeholder="5k loop, coffee after" data-testid="run-note-input" />
            <button className="go" type="submit" disabled={!ready} data-testid="generate-invites-button">{c.button}</button>
          </form>
        ) : (
          <ul className="drafts">{runners.map((s) => <InviteDraft key={s.id} s={s} run={run} kind={kind} />)}</ul>
        )}
      </div>
    </div>
  );
};
